<script>
import { mapActions } from 'vuex'
import { getHandoverString } from '@/utils/stringHandover'

export default {
  methods: {
    ...mapActions('session', ['setToken']),

    // URLSearchParamsオブジェクトからクエリオブジェクトを作成
    createQueryObject(searchParamsString) {
      const result = {}
      if (!searchParamsString) return result

      const searchParams = new URLSearchParams(searchParamsString)
      searchParams.forEach((value, key) => {
        result[key] = value
      })
      return result
    },

    // UTMパラメータをクエリオブジェクトにマージ
    mergeUtmParams(queryObj) {
      const params = getHandoverString('utm')
      if (!params) return queryObj
      const utmParams = JSON.parse(params)
      return { ...queryObj, ...utmParams }
    },

    // リダイレクト処理
    redirect(path, queryObj = null) {
      if (queryObj && Object.keys(queryObj).length > 0) {
        this.$router.push({ path, query: queryObj }).catch(() => {})
      } else {
        this.$router.push({ path }).catch(() => {})
      }
    }
  },

  created() {
    const sessionToken = this.$route.query.t

    // トークンがない場合はログインページへリダイレクト
    if (!sessionToken) {
      this.redirect('/login')
      return
    }

    // トークンを保存
    this.setToken(sessionToken)

    // 保存されていた遷移元のパスを取得
    const redirectPath = sessionStorage.getItem('redirect_after_login')
    sessionStorage.removeItem('redirect_after_login')

    // 遷移元のパスがある場合はそちらへリダイレクト
    if (redirectPath) {
      // `/r/` で始まるパスは、直接リダイレクト (web-contents-v2)
      if (redirectPath.startsWith('/r/')) {
        window.location.href = redirectPath
        return
      }

      // パスとクエリパラメータを分離
      const [pathPart, queryPart] = redirectPath.split('?')

      // 元のクエリとUTMパラメータをマージ
      const queryObj = this.createQueryObject(queryPart)
      const mergedQuery = this.mergeUtmParams(queryObj)

      this.redirect(pathPart, mergedQuery)
      return
    }

    // デフォルトのリダイレクト先（マイページ）へ
    const defaultPath = '/mypage/'
    const utmQueryObj = this.mergeUtmParams({})
    this.redirect(defaultPath, utmQueryObj)
  }
}
</script>

<style scoped></style>
